import '../styles/about.css';
import '../styles/landing.css';
import '../styles/project.css';
import { Container, Col, Row } from 'react-bootstrap';
import selfImg from '../assets/img/about-port no-bg.png';
import { renderTextBlock } from '../components/RenderTextBlocks';
import { useProjectTracker } from '../useProjectTracker';
import { useMediaQuery } from 'react-responsive';
import 'animate.css';
import { GitHub, LinkedIn, Mail, Twitter } from '@mui/icons-material';
import ProjectTabsLatest from 'src/components/ProjectTabsLatest';
import { latestWeb, latestMobile } from 'src/projects/ProjectLists';
import itchIcon from "../assets/img/itchio-textless-white.svg";

function Landing() {

  var projects = latestWeb;
  var projectsMobile = latestMobile;


  useProjectTracker();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <>
      <section className="banner" id="home">
        <Container className="width-base banner-container">
          <div className="banner-text banner-row align-items-center justify-content-center text-center about-top" style={{ paddingTop: isMobile ? "1rem" : "2rem"}}>
            <Col size={12} md={7} className="banner-col banner-col-left">
              <h1 className={isMobile ? "h1-mobile" : ""}>Lucas Coutinho<span style={{ color: "var(--color-accent)", transition: "color 0.2s ease-in-out" }}>.</span></h1>
              <h5 className={isMobile ? "h4-mobile" : ""}>
                {renderTextBlock(`A professional Game Programmer from Brazil`)}
                {/* <span style={{ color: "var(--text-color-primary)", transition: "color 0.2s ease-in-out" }}>Game</span>
              <span className="txt-rotate" data-rotate={toRotate}>
                <span className="wrap">{getStyledText(text, isDeleting, toRotate[loopNum % toRotate.length])}</span>
              </span> */}
              </h5>
              <p>
                {renderTextBlock(`Hello! I'm a passionate game programmer and developer who loves to create new worlds and fun experiences. Mainly using Unity.`)}
              </p>

              <div className="banner-links">
                <a href="/projects" className="banner-link">
                  <p>See all projects</p>
                </a>

                {/* <a href="/about" className="banner-link-mute">
                  <p>About me</p>
                </a> */}

                <div className={isMobile ? "banner-social-icon" : "banner-social-icon"}>
                  <a href="mailto:contact@lucascoutinho.dev" target="_blank" rel="noopener noreferrer"><Mail /></a>
                  <a href="https://linkedin.com/in/lucasctnh" target="_blank" rel="noopener noreferrer" ><LinkedIn /></a>
                  <a href="https://github.com/lucasctnh" target="_blank" rel="noopener noreferrer" id="banner-git"><GitHub /></a>
                  <a href="https://lucasctnh.itch.io/" target="_blank" rel="noopener noreferrer" id="banner-itch"><img src={itchIcon} alt="Itch.io" /></a>
                  <a href="https://x.com/lucas_ctnh" target="_blank" rel="noopener noreferrer" id="banner-x"><Twitter /></a>
                </div>
              </div>

            </Col>

            <Col size={12} md={5} className="banner-col banner-col-right" style={{ alignSelf: "center" }}>
              <img src={selfImg} alt="Portrait" className="about-image" style={{ maxHeight: "31rem" }} />
            </Col>
          </div>
        </Container>
        <button className="scroll-btn">
          {/* Add your button content here, e.g., an icon */}
        </button>
      </section>

      <section className="latest" id="latest">
        <div className="latest-text">
          <div className="latest-divider"></div>
          <p>Some of my latest works</p>
          <div className="latest-divider"></div>
        </div>
        <Container className="project-container">
          <Row className={isMobile ? "project-mobile" : ""}>
            <Row size={12} className="d-flex justify-content-center no-padding">
              {/* <h2>Projects</h2>
              <p>Dive into my game development journey: personal highlights, professional projects I've worked on, and some side quests I've done.</p> */}
              <ProjectTabsLatest latest={isMobile ? projectsMobile : projects} />
              {/* {isMobile && <ProjectTabsMobile all={allProjects} prof={professionalProjects} perso={personalProjects} side={sideProjects} />} */}
            </Row>
          </Row>
        </Container>
        {/* <img className="background-image-right" src={colorSharp2}></img> */}
      </section>
    </>);
}

export default Landing;